export enum ActionType {
    COACHING_DETAIL__BSD__LOAD = 'COACHING_DETAIL__BSD__LOAD',
    COACHING_DETAIL__BSD__LOAD_RESULT = 'COACHING_DETAIL__BSD__LOAD_RESULT',
    COACHING_DETAIL__BSD__CHECKBOX_SELECTED = 'COACHING_DETAIL__BSD__CHECKBOX_SELECTED',
}
